import { InspectionProposalType, InspectionType, WorksInspectionCost } from '../../types';

// export const getProposals = (
//   inspections: InspectionInterface,
//   inspectionProposals: InspectionProposalInterface,
//   inspectionIds: IdRef[],
// ): InspectionProposalType[] => inspectionIds.reduce((proposals, inspectionId) => {
//   if (inspections?.[inspectionId]?.scheduledProposalId) {
//     const { scheduledProposalId } = inspections[inspectionId];
//     const proposal = inspectionProposals[scheduledProposalId];
//     if (proposal) proposals.push(proposal);
//   }
//   return proposals;
// }, [] as InspectionProposalType[]);

export const getPay = (proposals: InspectionProposalType[]): number => (
  proposals.reduce((sum, proposal) => sum + (proposal?.contractorFee || 0) || 0, 0)
);

export const getPlatformFee = (proposals: InspectionProposalType[]): number | null => (
  proposals.some((proposal) => !proposal.totalFee) ? null
    : proposals.reduce((sum, proposal) => (
      sum + ((proposal?.totalFee || 0) - (proposal?.contractorFee || 0))
    ), 0)
);

export const getPlatformFeePercentage = (proposals: InspectionProposalType[]): number | null => {
  const platformFee = getPlatformFee(proposals);
  if (!platformFee) return null;

  const totalFee = proposals.reduce((sum, proposal) => sum + (proposal?.totalFee || 0), 0);
  if (totalFee === 0) return null;

  return (platformFee / totalFee) * 100;
};

export const getInspectionCosts = (
  proposals: InspectionProposalType[],
  inspection: InspectionType,
): WorksInspectionCost[] => (
  proposals.reduce((costs, { totalFee }) => {
    const { id, inspectionType } = inspection;
    costs.push({
      id,
      inspectionType,
      fee: (totalFee || 0),
    });
    return costs;
  }, [] as WorksInspectionCost[])
);

export const getIsPaid = (proposals: InspectionProposalType[]): boolean => (
  proposals.every((proposal) => proposal?.contractorPaidAt !== null)
);

export const getPaidDate = (proposals: InspectionProposalType[]): number | undefined => {
  const paidAtArr: number[] = proposals.map((proposal) => proposal?.contractorPaidAt);
  return Math.max(...paidAtArr);
};
